import { Dispatch } from "redux";
import apiLibrary from "services/api";
import { Toasts } from "view/components/Toasts";
import {
  GET_REPORT_NOTIFICATIONS,
  GET_REPORT_NOTIFICATIONS_STATE,
} from "../action-types";
import { generateQueryStringForUsers } from "utils/convertFiltersToQueryString";

/**
 * FETCH DASHBOARD WIDGETS -- REPORT NOTIFICATIONS
 * @returns
 */
export const fetchReportNotifications =
  () => async (dispatch: Dispatch, getState: any) => {
    dispatch({
      type: GET_REPORT_NOTIFICATIONS_STATE,
      payload: {
        stateIs: "Pending",
      },
    });
    try {
      const currentState = getState();

      const params = generateQueryStringForUsers(
        currentState.Filters.dashboardFilter
      );

      if (params.datePeriod) {
        delete params.datePeriod;
      }
      const { data } =
        await apiLibrary.Dashboard.widgets.getReportNotifications(params);
      dispatch({
        type: GET_REPORT_NOTIFICATIONS,
        payload: { data },
      });
    } catch (error: any) {
      const errorMsg = error?.response?.data?.message ?? error?.message;
      Toasts.error(errorMsg);

      dispatch({
        type: GET_REPORT_NOTIFICATIONS_STATE,
        payload: {
          stateIs: "Error",
        },
      });
      console.log(
        "An error occurred while fetching the report notifications:",
        error
      );
      // dispatch(fetchError(error))
    } finally {
      // dispatch(loadingState(false))
    }
  };
